export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/combination-provider-arrow-bottom.6e746d7a-bec0a6.svg";